import { initializeApp } from "firebase/app";
import { doc, getDoc, getFirestore, increment, updateDoc } from "firebase/firestore";

const firebaseConfigKlima = {
    apiKey: "AIzaSyBzrvRqbzSqk-oHEYO9blJEd5aHgfIubQs",
    authDomain: "saikai-klima.firebaseapp.com",
    projectId: "saikai-klima",
    storageBucket: "saikai-klima.appspot.com",
    messagingSenderId: "474581391328",
    appId: "1:474581391328:web:0f76f8331a1eb1eb5abd85",
    measurementId: "G-ZHN5PQQ9YZ",
};

const firebaseConfigPredict = {
    apiKey: "AIzaSyDC61mnYpYrFdgrLI0LphZ-j3WxAPQ_x7Q",
    authDomain: "denryoku-predict.firebaseapp.com",
    projectId: "denryoku-predict",
    storageBucket: "denryoku-predict.appspot.com",
    messagingSenderId: "917012287526",
    appId: "1:917012287526:web:a9677895beb88df300d6e7"
};

export const appKlima = initializeApp(firebaseConfigKlima, 'klima');
export const appPredict = initializeApp(firebaseConfigPredict, 'predict');

export const dbKlima = getFirestore(appKlima);
export const dbPredict = getFirestore(appPredict);

export const getPredictData = async () => {
    const today = new Date();

    const docRef = doc(dbPredict, `${today.getDate()}`, 'pred');
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
        const data = docSnap.data();
        const predictData = Math.floor(data?.pred);
        return predictData;
    } else {
        return -1;
    }
}

export const getAndUpdateAverage = async (_score: number) => {
    const docRef = doc(dbKlima, "statistics", "statistics");

    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
        const data = docSnap.data();

        const sum = data.sum + _score;
        const counter = data.counter + 1;

        const _average = sum / counter;

        await updateDoc(docRef, {
            sum: increment(_score),
            counter: increment(1)
        });

        return Math.floor(_average)
    } else {
        return -1;
    }
}